// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"f3934645","166":"cb432b54","241":"9c8f5fc7","333":"2f80acc1","418":"729d4e0b","511":"9953e94d","518":"5ed23334","578":"8953af27","603":"91b92029","837":"457fe82e","900":"8fbb4e4f","987":"1752d30b"}[chunkId] + ".chunk.js";
};